var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var store = {
    get: function (key) {
        var storedItem = localStorage.getItem(key);
        if (storedItem === null) {
            return storedItem;
        }
        try {
            return JSON.parse(storedItem);
        }
        catch (e) {
            return storedItem;
        }
    },
    set: function (key, value) {
        localStorage.setItem(key, typeof value === 'string' ? value : JSON.stringify(value));
    },
    append: function (key, value) {
        this.set(key, __assign(__assign({}, (this.get(key) || {})), value));
    },
    appendDiffTypes: function (key, value) {
        var data = this.get(key);
        if (!data) {
            this.set(key, value);
            return;
        }
        if (Array.isArray(data) && Array.isArray(value)) {
            this.set(key, __spreadArray(__spreadArray([], data, true), value, true));
            return;
        }
        if (typeof data === 'object' && typeof value === 'object') {
            this.set(key, __assign(__assign({}, data), value));
            return;
        }
        this.set(key, value);
    },
    remove: function (key) {
        localStorage.removeItem(key);
    },
    clear: function () {
        localStorage.clear();
    },
    getAnswers: function () {
        return this.get('answers') || {};
    },
    storeMarketingInfo: function () {
        this.storeUtmParams(window.location.search);
        this.storeLastUtmParams(window.location.search);
        this.storeScreenResolution(window.screen.width, window.screen.height, window.devicePixelRatio);
    },
    storeScreenResolution: function (width, height, pixelRatio) {
        this.append('marketing', {
            screen: {
                width: width * pixelRatio,
                height: height * pixelRatio,
            },
        });
    },
    storeUtmParams: function (queryString) {
        var utmParams = this.parseUtmParams(queryString);
        // this check is to ensure that the utm parameters will be preserved from the first opening of the site
        if (Object.keys(utmParams).length && this.getMarketingInfo('utmParams') === undefined) {
            this.append('marketing', { utmParams: utmParams });
        }
    },
    storeLastUtmParams: function (queryString) {
        var lastUtmParams = this.parseUtmParams(queryString);
        if (Object.keys(lastUtmParams).length) {
            lastUtmParams['utm_creative'] =
                lastUtmParams['utm_creative'] || this.getMarketingInfo('utmParams')['utm_creative'];
            this.append('marketing', {
                lastUtmParams: lastUtmParams,
            });
        }
    },
    parseUtmParams: function (queryString) {
        return queryString
            .substring(1)
            .split('&')
            .filter(function (pair) { return pair.startsWith('utm'); })
            .map(function (pair) { return pair.split('=').map(decodeURIComponent); })
            .reduce(function (result, _a) {
            var _b;
            var key = _a[0], value = _a[1];
            return (__assign(__assign({}, result), (_b = {}, _b[key] = value, _b)));
        }, {});
    },
    getMarketingInfo: function (key) {
        if (key === void 0) { key = null; }
        var marketing = this.get('marketing') || {};
        return key ? marketing[key] : marketing;
    },
    storeCustomerUuid: function (uuid) {
        var params = new URLSearchParams(window.location.search);
        var customerUuid = params.get('cid') || params.get('customerUuid') || uuid;
        if (!this.getCustomerUuid()) {
            this.setCustomerUuid(customerUuid);
        }
    },
    setCustomerUuid: function (value) {
        this.set('__cid', value);
    },
    getCustomerUuid: function () {
        return this.get('__cid') || '';
    },
    setEventId: function (value) {
        this.set('__eid', value);
    },
};
export default store;
window.store = store;
